module.exports = {
  KUNDE: { api: 'KUNDE', human: 'Kunde' },
  INTERESSENT: { api: 'INTERESSENT', human: 'Interessent' },
  MITARBEITER: { api: 'MITARBEITER', human: 'Mitarbeiter' },
  EX_KUNDE: { api: 'EX_KUNDE', human: 'Ehemaliger Kunde' },
  EX_INTERESSENT: { api: 'EX_INTERESSENT', human: 'Ehemaliger Interessent' },
  EX_MITARBEITER: { api: 'EX_MITARBEITER', human: 'Ehemaliger Mitarbeiter' }
}
